import React from "react";
import './BookingModal.css';
import ActionModal from "../../core/ActionModal";
import {Booking, Company, ProfilePackage} from "../../../models";
import SlotDetails from "../../slots/SlotDetails/SlotDetails";
import BookingButtons from "../BookingButtons";
import {useAppSelector} from "../../../redux/hooks";
import {profilePackageByIdSelector} from "../../../redux/profile-packages";
import {profileByIdSelector} from "../../../redux/customers";
import {formatFreezeDate, isTsWithinFreeze} from "../../../utils/frozen";
import {IonText} from "@ionic/react";


interface BookingModalProps {
    isOpen: boolean;
    onClose: () => void;

    company?: Company;
    booking?: Booking;
    profilePackage?: ProfilePackage;
}

const BookingModal: React.FC<BookingModalProps> = (
    {
        isOpen,
        onClose,
        company,
        booking,

    }) => {

    const profilePackage = useAppSelector((state) => profilePackageByIdSelector(state, booking?.profilePackageId));
    const profile = useAppSelector((state) => profileByIdSelector(state, profilePackage?.learnerId));

    // Same rule as the home accordion chips: a recurring booking is suspended
    // for as long as the freeze runs; a dated one only when its date is inside.
    const frozenUntil = profile?.frozenUntil ?? null;
    const isBookingFrozen = !!booking && (
        profilePackage?.isRecurring ? !!frozenUntil : isTsWithinFreeze(frozenUntil, booking.startedTimestamp)
    );

    return (
        <ActionModal isOpen={isOpen} onClose={onClose} title={"Booking Details"}>
            {isBookingFrozen && frozenUntil &&
                <IonText color="danger">
                    <p className="booking-modal-frozen-notice">
                        This profile is frozen until {formatFreezeDate(frozenUntil)} — this session can't be attended.
                    </p>
                </IonText>
            }
            {booking && booking.slot && <SlotDetails actionsDisabled={false} slot={booking?.slot} lessonDateTs={!profilePackage?.isRecurring ? booking.startedTimestamp : undefined} />}
            {booking && company && profilePackage &&
                <BookingButtons
                    expand="full"
                    company={company}
                    booking={booking}
                    profilePackage={profilePackage}
                />
            }
        </ActionModal>
    );
};

export default BookingModal;
